import { render, staticRenderFns } from "./ProjectSectionTimelineCard.vue?vue&type=template&id=4afda27d"
import script from "./ProjectSectionTimelineCard.vue?vue&type=script&lang=js"
export * from "./ProjectSectionTimelineCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports